<template>
    <div>
        <div class="row mb-4 mt-4">
            <div class="col">
                <div class="card">
                    <div id="collapseExample" class="collapse show">
                        <div class="card-body">
                            <div class="container">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="card-text">
                                                    <h6>There are <span
                                                            style='color:red;font-size:20px'>three steps</span> in total
                                                        to finish the annotation task for each passage. We provide
                                                        step-by-step instruction below using Passage #1. In this HIT, you need to <strong> write at least
                                                            3 questions in total</strong> for the three passages provided.
                                                        You can see your question count in the interface.</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-4">
                                        <div class="card sticky-top">
                                            <div class="card-header">
                                                <h4>Passage #1</h4>
                                            </div>
                                            <div class="card-body">
                                                <div id="passage-sample" class="card-text">
                                                    London shares were
                                                    <mark>depressed</mark>
                                                    initially by overnight
                                                    <mark>losses</mark>
                                                    in New York and by the
                                                    <mark>drop</mark>
                                                    in sterling
                                                    after Mr. Lawson's
                                                    <mark>resignation</mark>
                                                    . It <span
                                                        style='background-color: lightblue;'>showed</span> some early
                                                    resilience after central bank support
                                                    <mark>firmed</mark>
                                                    sterling, but
                                                    the weight of Wall Street late in London trading, and signs of
                                                    further
                                                    weakness in the British pound, proved a hefty load to
                                                    <mark>bear</mark>
                                                    . New York stocks
                                                    <mark>recovered</mark>
                                                    some of
                                                    their
                                                    <mark>losses</mark>
                                                    after the London market
                                                    <mark>closed</mark>
                                                    .
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-8" id="exampleQuestions">
                                        <div class="card mb-2">
                                            <div class="card-header">
                                                <h4>Step 1: Read the passage carefully</h4>
                                            </div>
                                            <div class="card-body">
                                                <div class="card-text">
                                                    Before you start your annotation, the first thing you need to do is
                                                    to read the given passage (on the left column) <strong>VERY
                                                    CAREFULLY</strong>. In this step, you can see:
                                                    <ul>
                                                        <li>Highlighted words are examples of event <b>actions</b>, from
                                                            which you can select significant events.
                                                        </li>
                                                        <li>While some of the event action words may look the same in
                                                            their surface forms, they could represent different events
                                                            depending on their <strong>subject, object, time</strong>,
                                                            and <strong>location</strong> (we call these event
                                                            arguments). You need to consider all of those event
                                                            arguments and the event actions themselves when you think of
                                                            an event.
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card mb-2">
                                            <div class="card-header">
                                                <h4>Step 2: Event Action Identification</h4>
                                            </div>
                                            <div class="card-body">
                                                <div class="card-text">
                                                    In this step, you need to:
                                                    <ul>
                                                        <li>Identify event actions that are <strong>crucial for the
                                                            narrative understanding</strong> in the passage.
                                                        </li>
                                                        <!--
                                                        <li>For each identified event, you are required to choose
                                                            <strong>its duration</strong> in the context.
                                                        </li>
                                                        -->
                                                        <li><span style='color:Red;'>If you believe some event actions are significant but they are not originally highlighted, you can also select them. However, think carefully about the event definition before you do so.</span>
                                                        </li>
                                                    </ul>
                                                    <div>For example in Passage #1: (listed in the order of appearance)</div>
                                                    <table class="paleBlueRows">
                                                        <thead>
                                                        <tr>
                                                            <th>Selected Event</th>
                                                            <!--
                                                            <th>Event Duration</th>
                                                            -->
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr>
                                                            <td>depressed</td>
                                                            <!--
                                                            <td>Day</td>
                                                            -->
                                                        </tr>
                                                        <tr>
                                                            <td>losses</td>
                                                            <!--
                                                            <td>Day</td>
                                                            -->
                                                        </tr>
                                                        <tr>
                                                            <td>drop</td>
                                                            <!--
                                                            <td>Day</td>
                                                            -->
                                                        </tr>
                                                        <tr>
                                                            <td><span style='color:Red;'>showed</span></td>
                                                            <!--
                                                            <td>Hour</td>
                                                            -->
                                                        </tr>
                                                        <tr>
                                                            <td>bear</td>
                                                            <!--
                                                            <td>Day</td>
                                                            -->
                                                        </tr>
                                                        <tr>
                                                            <td>recovered</td>
                                                            <!--
                                                            <td>Hour</td>
                                                            -->
                                                        </tr>
                                                        <tr>
                                                            <td>losses</td>
                                                            <!--
                                                            <td>Month</td>
                                                            -->
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                    <br>
                                                    <div class='card-text'>
                                                        <span style='color:DarkGreen;'>[Explanation] Take the event action <strong>*showed*</strong> as an example, you can identify its <strong>subject</strong> as "it" and <strong>object</strong> as "early resilience", and its <strong>time</strong> as "after central bank support firmed sterling." Although it is not a highlighted word, you can still choose it beause it's important in the narrative and the event arguments are either expicitly mentioned or can be inferred from the passage.</span>
                                                    </div>
                                                    <br>
                                                    <div class="card-text">
                                                        There are some key points that you can see in the example:
                                                        <ul>
                                                            <li>Not all the events are important to the passage and we
                                                                <strong>DON'T</strong> want
                                                                <strong>*unimportant*</strong> events.
                                                            </li>
                                                            <!--
                                                            <li>We don't require event duration to be very precise. They
                                                                are here to help you ask event relation questions. This
                                                                point will be clearer at Step 3.
                                                            </li>
                                                            -->
                                                            <li>Two action words with the same textual form can indicate different events. For
                                                                example, there are two <strong>*losses*</strong> in the
                                                                passage, which differ drastically in their event
                                                                arguments.
                                                            <li>Some cases are not clear until you try to ask a question
                                                                in Step 3. If you are stuck, feel free to move to Step
                                                                3. You can always come back to Step 2 to edit your
                                                                selections.
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card mb-2">
                                            <div class="card-header">
                                                <h4>Step 3: Ask questions about event relations</h4>
                                            </div>
                                            <div class="card-body">
                                                <div class="card-text">
                                                    In this step, you need to ask questions that belong to the <b><span
                                                        style='color:red;'>three</span></b> event relation types we
                                                    defined (review it by clicking on the "Overview" tab above) and
                                                    provide corresponding answers. <strong>Your questions don't need to
                                                    cover all five types, but we encourage you to diversify your
                                                    question types</strong>.
                                                </div>
                                                <div class="card-text">
                                                    Please notice that there are four <strong>restrictions to your
                                                    questions & answers</strong>:
                                                    <ul>
                                                        <li>Your question should ask relations about one of your
                                                            selected events in Step 2.
                                                        </li>
                                                        <li>For sub-event relation, you can ask a question about an
                                                            <strong>imaginary complex event</strong> that is not
                                                            explicitly mentioned in the passage but can be easily
                                                            inferred. See our example below.
                                                        </li>
                                                        <li>Each of your <strong>answers</strong> should be <strong>a
                                                            span that contains an event</strong> you selected in the
                                                            passage.
                                                        </li>
                                                        <li>You need to point out <strong>*all*</strong> events that can
                                                            answer your questions.
                                                        </li>
                                                    </ul>
                                                    <span style='color:Red;'>Due to these restrictions, you are encouraged to design questions carefully and be creative!</span>
                                                </div>
                                                <br>
                                                <!--                                              <span style='font-size:22px;font-weight:bold'>[Examples]</span><br>-->
                                            </div>
                                        </div>

                                        <div class="card mb-2">
                                            <div class="card-header">
                                                <h4>&#9888; Step 3: <span style="color: red"><strong>Common Mistakes</strong></span>️</h4>
                                            </div>
                                            <div class="card-body">
                                                We list 5 common mistakes participants made during our pilot study. Please read them and try to avoid making the same mistakes in your work. You can see examples of these mistakes following the valid QAs for each passage below.<br/>
                                                <ol>
                                                    <li><span style="color: red"><strong> [Coreference] Don't ask questions about event arguments. </strong></span>Remember
                                                        that we define event arguments as an event action's subject,
                                                        object, time and locations. For [Coreference] relation, events in the question and answer must share the same arguments. 
                                                        However, some participants mistakenly think that event A's arguments form a [Coreference] relation with A. 
                                                        For example, "participate in planning": "participate" does not corefer to "planning" as "planning" is effectively the object of "participate;" or "hope for a change": "hope" does not corefer to "change." 
                                                    </li>

                                                    <li><span style="color: red"><strong> [Sub-event] Questions do not include any complex and concrete event. </strong></span>
                                                        <br/></li>

                                                        Sub-event questions <strong>must have</strong> a complex event that contains a group of sub-events. The complex event itself <strong>must be concrete</strong> even if it's imaginary. Words such as "happen", "happened", "action", "incident", etc. are too broad and hence, are not concrete action words.

                                                    <li><span style="color: red"><strong> Questions do not include a highlighted event. </strong></span>
                                                        Except for [Sub-event] question, we requ ire all other types of questions to include a highlighted event. You are allowed to use a different form of event actions in your questions. For example, in Passage #1, we highlight "drop" and
                                                        "resignation," but you can use "dropped" and "resign" if that makes your question natural. However, you MUST include an event in your question. <br/></li>

                                                    <li><span style="color: red"><strong> Question-answer pairs do not belong to our event relation types. </strong></span>
                                                        Recall that we define five relation types, and the events in your question and answer MUST form one of these relations. A typical error
                                                        is asking questions about object coreference rather than event coreference. For example,
                                                        what does "the enemy" refer to? Clearly "enemy" is not an event, so please avoid asking such questions.
                                                    </li>


                                                    <li><span style="color: red"><strong> Answers are either not complete or not concise.</strong></span>
                                                        We set a hard limit in the working area that your answers must be longer than 1 word and shorter than 12 words. However, please use your best judgement to select answers that are complete and concise, i.e. your answers correctly and naturally answer the question, 
                                                        but are as concise as possible. 

                                                    </li>

                                                </ol>

                                                <br>
                                            </div>
                                        </div>


                                        <div class="card mb-2">
                                            <div class="card-header">
                                                    <h4>Valid QAs for Passage #1</h4>
                                            </div>
                                            <div class="card-body">

                                                <p class="card-text">
                                                    <b style='color:Dodgerblue;'>[Coreference Question] What do the recovered losses of New York stocks refer to?</b> <br/>
                                                    <span style='color:black;'>[Answer] </span>
                                                    <span
                                                        style='color:black; font-style: italic;'>overnight losses in New York </span><br/>
                                                    <span style='color:darkgreen;'>[Explanation] </span><span
                                                        style='color:darkgreen; font-style: italic;'>We can easily infer from this passage that the two events "losses" share the same subject of "New York stocks," location "New York" and time "overnight." So these two "losses" are co-referred or the same event. </span>
                                                    <br/>
                                                </p>
                                            </div>
                                        </div>

                                        <div class="card mb-2">
                                            <div class="card-header">
                                                    <h4 style='color:red;'>Common Mistakes for Passage #1</h4>
                                            </div>
                                            <div class="card-body">

                                                <p class="card-text">
                                                    <b style="color:Dodgerblue;">[Sub-event Question] What
                                                        happened to London shares after Mr. Lawson's
                                                        resignation?</b> <br/>
                                                    <span style='color:black;'>[Answer] </span><span
                                                        style='color:balck; font-style: italic;'>were depressed; showed some early resilience; a hefty load to bear.</span><br>
                                                    <strong>Why Invalid?</strong> <b>&#8594;</b> <span
                                                        style="color: red"><strong>Questions do not include a complex and concrete event (Common Mistakes 2 above).</strong></span><br/>
                                                    <span style='color:darkgreen;'>[Explanation] </span><span
                                                        style='color:darkgreen; font-style: italic;'>Sub-event questions <strong>must have</strong> a complex event that contains a group of sub-events. The complex event itself <strong>must be concrete</strong> such as "fluctuate" even if it's imaginary. "What happened" is not a concrete event.</span>
                                                    <br/>
                                                </p>

                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="col-lg-4">
                                            <div class="card sticky-top">
                                                <div class="card-header">
                                                    <h4>Passage #2</h4>
                                                </div>
                                                <div class="card-body">
                                                    <div id="passage-sample" class="card-text">
                                                        Four Iraqis, including a police commando, were <span
                                                            style="background-color: lightpink">killed</span> and seven
                                                        others <span style="background-color: lightpink">wounded</span>
                                                        in two roadside bomb
                                                        <mark>attacks</mark>
                                                        in Baghdad on Monday, a police source said. "A roadside bomb
                                                        <mark>struck</mark>
                                                        a police commando patrol at about 8:30 a.m. in Saidiyah district
                                                        in southern Baghdad," Ahmed Abdullah from Baghdad police told
                                                        Xinhua. Another roadside bomb
                                                        <mark>exploded</mark>
                                                        at about 9:00 a.m. in the Camp Sarah area in southeastern
                                                        Baghdad shortly after an Iraqi army convoy
                                                        <mark>passed</mark>
                                                        by,' Abdullah said. Insurgents frequently
                                                        <mark>target</mark>
                                                        the fledgling Iraqi security troops,
                                                        <mark>accusing</mark>
                                                        them of collaborating with the US occupation forces.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-8" id="exampleQuestions">
                                            <div class="card mb-2">
                                                <div class="card-header">
                                                    <h4>Valid QAs for Passage #2</h4>
                                                </div>
                                                <div class="card-body">

                                                    <p class="card-text">
                                                        <b style='color:Dodgerblue;'>[Sub-event Question] What events are included the attacks?</b> <br/>
                                                        <span style='color:black;'>[Answer] </span><span
                                                            style='color:black; font-style: italic;'> A roadside bomb struck a police commando patrol; Another roadside bomb exploded.</span><br/>
                                                        <span style='color:darkgreen;'>[Explanation] </span><span
                                                            style='color:darkgreen; font-style: italic;'>From the passage, we can easily infer that two attacks includes one bomb struck a police commando patrol and another bomb exploded in the Camp Sarah area.</span>
                                                        <br/>
                                                    </p>
                                                </div>
                                            </div>

                                            <div class="card mb-2">
                                                <div class="card-header">
                                                    <h4 style='color:red;'>Common Mistakes for Passage #2</h4>
                                                </div>
                                                <div class="card-body">
                                                    <p class="card-text">
                                                        <b style="color:Dodgerblue;">[Question] What lead to four Iraqis
                                                            got killed and seven others wounded?</b> <br/>
                                                        <span style='color:black;'>[Answer] </span><span
                                                            style='font-style: italic;'>Two roadside bomb attacks</span>
                                                        <br/>
                                                        <strong>Why Invalid?</strong> <b>&#8594;</b> <span
                                                            style="color:red"><strong>Questions do not include a highlighted event (Common Mistakes 3 above).</strong></span><br/>
                                                        <span style='color:darkgreen;'>[Explanation] </span><span
                                                            style='color:darkgreen; font-style: italic;'>The significant events in the question are "killed" and "wounded", but they are not highlighted in the passage (marked in pink).</span><br/>

                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-4">
                                            <div class="card sticky-top">
                                                <div class="card-header">
                                                    <h4>Passage #3</h4>
                                                </div>
                                                <div class="card-body">
                                                    <div id="passage-sample" class="card-text">
                                                        'We
                                                        <mark>hope</mark>
                                                        , therefore, that the Iranian regime will
                                                        <mark>set</mark>
                                                        aside threats and confrontation and will
                                                        <mark>begin</mark>
                                                        immediately to
                                                        <mark>cooperate</mark>
                                                        with all the requirements of the Security Council.' The
                                                        spokesman's comments
                                                        <mark>echoed</mark>
                                                        an earlier statement by the State Department. 'We
                                                        <mark>assume</mark>
                                                        further
                                                        <mark>reductions</mark>
                                                        in Iran's already insufficient cooperation would likely
                                                        <mark>lead</mark>
                                                        to additional IAEA
                                                        <mark>reports</mark>
                                                        of additional Iranian non-compliance,' spokesman Gonzalo
                                                        Gallegos said. Earlier Wednesday, Iran's parliament approved a
                                                        bill obliging the government to '
                                                        <mark>revise</mark>
                                                        its cooperation' with the UN nuclear watchdog in retaliation for
                                                        Security Council sanctions
                                                        <mark>imposed</mark>
                                                        on Tehran.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-8" id="exampleQuestions">

                                            <div class="card mb-2">
                                                <div class="card-header">
                                                    <h4>Valid QAs for Passage #3</h4>
                                                </div>
                                                <div class="card-body">
                                                    <p class="card-text">
                                                        <b style='color:Dodgerblue;'>[Coreference Question] What does
                                                            Iran's revision of its cooperaion with UN watchdog refer
                                                            to?</b> <br/>
                                                        <span style='color:black;'>[Answer] </span><span
                                                            style='color:black; font-style: italic;'> further reductions in Iran's already insufficient cooperation. </span><br/>
                                                        <span style='color:darkgreen;'>[Explanation] </span><span
                                                            style='color:darkgreen; font-style: italic;'> From the passage, we can see that Iran's revision of the plan basically means reduction of cooperation. Thus, "revise" and "reductions" form a [Coreference] relation. </span>
                                                        <br/>
                                                    </p>

                                                </div>
                                            </div>

                                            <div class="card mb-2">
                                                <div class="card-header">
                                                    <h4 style='color:red;'>Common Mistakes for Passage #3</h4>
                                                </div>

                                                <div class="card-body">
                                                <div class="card-text">
                                                    <p class="card-text">
                                                        <b style="color:Dodgerblue;">[Coreference Question] What does
                                                            the spokesman hope?</b> <br/>
                                                        <span style='color:black;'>[Answer] </span><span
                                                            style='font-style: italic;'>Iranian regime will set aside threats</span>
                                                        <br/>
                                                        <strong>Why Invalid?</strong> <b>&#8594;</b> <span
                                                        style="color: red"><strong>Don't ask question about event arguments (Common Mistakes 1 above).</strong></span><br/>
                                                        <span style='color:darkgreen;'>[Explanation] </span><span
                                                            style='color:darkgreen; font-style: italic;'>The answer is the content (object) of the event "hope." Therefore, they cannot form [Corefrence] relation as we explain above.</span><br/>
                                                    </p>

                                                </div>
                                             </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h2>It's great that you have made it here. A quick recap:</h2>

                <ol>
                    <li>Mark all the events that are important to the passage.</li>
                    <li>Ask questions of the <strong>*designated three question types*</strong>.</li>
                    <li>You should provide <strong>*all*</strong> answers to the questions you created.</li>
                    <li>Despite of all the details, the core is still question-answering. If you're not sure about the
                        answer to a specific question, just ask yourself whether this QA pair sounds reasonable to you
                        as an English speaker.
                    </li>
                    <!--                  <li>You can provide feedback to us at the bottom of this page.</li>-->
                </ol>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'StepByStep',
        props: {
            max_bonus: Number,
            bonus_per_question: Number
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    table.paleBlueRows {
        font-family: "Arial Black", Gadget, sans-serif;
        border: 6px solid #FFFFFF;
        width: 100%;
        height: 15%;
        text-align: center;
    }

    table.paleBlueRows td, table.paleBlueRows th {
        border: 1px solid #FFFFFF;
    }

    table.paleBlueRows tbody td {
        font-size: 15px;
        text-align: center;
    }

    table.paleBlueRows thead {
        background: #0B6FA4;
        border-bottom: 5px solid #FFFFFF;
    }

    table.paleBlueRows thead th {
        font-size: 15px;
        font-weight: bold;
        color: #FFFFFF;
        text-align: center;
        border-left: 2px solid #FFFFFF;
    }

    table.paleBlueRows thead th:first-child {
        border-left: none;
    }

</style>
